// extracted by mini-css-extract-plugin
module.exports = {"HistoryContainer":"UserHistory_HistoryContainer__3L75A","Container":"UserHistory_Container__38zcj"};